var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"imgMax",staticClass:"copyright"},[_c('img',{style:({left: _vm.filterLeft(), top: _vm.filterTop(), width: _vm.imgWidth*2+'px'}),attrs:{"src":_vm.imgurl,"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }